import { Button } from 'antd';
import styles from './index.module.scss';

function SurveyIntro({ onStart }: { onStart: () => void }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.background} />
          <div className={styles.backgroundFilter} />

          <div className={styles.innerWrapper}>
            <h2 className={styles.title}>
              Service Workers: Not Getting the Tips You Deserve?
            </h2>
            <p className={styles.description}>
              Speak Up! What do you think is a FAIR tip in your industry?
            </p>
            <Button className={styles.button} onClick={onStart}>
              Answer Here
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SurveyIntro;
